module.exports = {
  // 'ruangkerja/user/login': {
  //   status: 'success',
  //   data: {
  //     token: 'companytoken',
  //     refreshToken: 'companyrefreshtoken',
  //   },
  // },
};
